import { Text } from "../Text";
import { Line } from "../Line";
import { TickSVG } from "../../assets/images/tick";
import React from "react";

export  function OrderPaidWidget({ order }) {
  return (
    <>
      <div
        className="bg-white-A700 flex md:flex-1 flex-col border items-start justify-start p-3 rounded-lg w-[67%] md:w-full">
        <Text>
          Track your order
        </Text>
        <Line className="my-4 bg-gray-300 h-px  mx-auto w-full" />
        <Text className="text-sm mb-4 font-light">
          Order code #: {order?.id}
        </Text>
        <div className="flex flex-row w-full">
          <div className="flex flex-row flex-grow items-center">
            <div
              className={`h-[30px] w-[30px] min-w-[30px] rounded-[50%] flex justify-center items-center bg-green-600 ${order?.paid === true ? " bg-green-600" : "bg-gray-200"} `}>
              {
                order?.paid === true && <TickSVG />
              }
            </div>
            <div
              className={`h-[6px] w-full inline-block ${order?.processed === true ? " bg-green-600" : "bg-gray-200"}`} />
          </div>
          <div className="flex flex-row flex-grow items-center">
            <div
              className={`h-[30px] w-[30px] min-w-[30px] rounded-[50%] flex items-center justify-center ${order?.processed === true ? " bg-green-600" : "bg-gray-200"}`}>
              {
                order?.processed === true && <TickSVG />
              }
            </div>
            <div
              className={`h-[6px] w-full inline-block ${order?.completed === true ? " bg-green-600" : "bg-gray-200"}`} />
          </div>
          <div
            className={`h-[30px] w-[30px] min-w-[30px] rounded-[50%] flex justify-center items-center ${order?.completed === true ? " bg-green-600" : "bg-gray-200"}`}>
            {
              order?.completed === true && <TickSVG />
            }
          </div>
        </div>

        <div className="flex flex-row w-full my-4">
          <div className="flex flex-row flex-grow items-center">
            <Text className="text-sm text-gray-600">Paid</Text>
          </div>
          <div className="flex flex-row flex-grow items-center">
            <Text className="text-sm text-gray-600">Processed</Text>
          </div>
          <div className="">
            <Text className="text-sm text-gray-600">Completed</Text>
          </div>
        </div>
      </div>
    </>
  );
}